module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_3009.196f8695.png";